const initLastChanceModule = () => {
    if ($('.last-chance-swiper').length > 0) {
        const swiper = new Swiper('.last-chance-swiper', {
            slidesPerView: 4,
            spaceBetween: 40,
            grabCursor: true,
            simulateTouch: true,
            preventClicks: true,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                    spaceBetween: 30,
                    navigation: {
                        enabled: false,
                    },
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    slidesPerGroup: 2,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                    slidesPerGroup: 2,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    slidesPerGroup: 3,
                },
                2560: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                    slidesPerGroup: 4,
                },
            },
        });

        // Set Timers
        const counters = $('.last-chance-swiper-item__counter [data-remaining]');
        if (counters.length > 0) {
            $.each(counters, (i, item) => {
                let remainingSeconds = Number($(item).data('remaining'));

                const counterElement = $(item);

                const counter = setInterval(() => {
                    remainingSeconds--;
                    if (remainingSeconds == 0) clearInterval(counter);

                    const remHours = Math.floor(remainingSeconds / 3600);
                    const remMins = Math.floor(remainingSeconds / 60) % 60;
                    const remSecs = remainingSeconds % 60;

                    let remStr = remHours < 10 ? `0${remHours}:` : `${remHours}:`;
                    remStr += remMins < 10 ? `0${remMins}:` : `${remMins}:`;
                    remStr += remSecs < 10 ? `0${remSecs}` : remSecs;

                    counterElement.text(remStr);
                }, 1000);
            });
        }
    }
}

export default initLastChanceModule;
